export default function(data) {
var __t, __p = '';
__p += '<div class="row-flex empty-saves">\n  <span class="icon heart"></span>\n  <div class="col large-11 medium-11 small-11">\n    <h3>You don\'t have any favorite stores yet.</h3>\n    <p>You can easily access deals and coupons for stores you love here, just click on the heart icon next to a store you love to favorite it.</p>\n  </div>\n</div>\n';
return __p
}